import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPlusComponent } from "./med-icon-plus.component";

@NgModule({
  declarations: [
    MedIconPlusComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPlusComponent,
  ],
})
export class MedIconPlusModule { }
